import { render, staticRenderFns } from "./payInfo.vue?vue&type=template&id=39c390c6&scoped=true&"
import script from "./payInfo.vue?vue&type=script&lang=js&"
export * from "./payInfo.vue?vue&type=script&lang=js&"
import style0 from "./payInfo.vue?vue&type=style&index=0&id=39c390c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c390c6",
  null
  
)

export default component.exports